module.exports = __webpack_public_path__ + "static/media/included7.01dfc138.svg";